import script from "./CompSearchDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CompSearchDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./CompSearchDetailsPage.vue?vue&type=style&index=0&id=52358dfc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52358dfc"]])

export default __exports__